import Vue from 'vue'
import Vuex from 'vuex'

// import more modules here as you convert them:
import ui from './modules/ui'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: { ui },
})
